import Http from '@/http';
import AuthService from '@/service/auth/authService';
import router from '@/router';
export default {
  get(endpoint, headers = {}, params = {}) {
    return Http.get(endpoint, {
      headers: this.assignHeaders(headers),
      params,
    });
  },

  assignHeaders(headers) {
    const token = AuthService.getToken();
    if (token) {
      return Object.assign(headers, {
        Authorization: `Bearer ${token.access_token}`,
      });
    } else {
      router.push('/') // Logout the user when token is null
      throw new Error('Invalid session');
    }
  },

  post(endpoint, data = {}, headers = {}) {
    return Http.post(endpoint, data, {
      headers: this.assignHeaders(headers),
    });
  },

  put(endpoint, data = {}, headers = {}) {
    return Http.put(endpoint, data, {
      headers: this.assignHeaders(headers),
    });
  },

  delete(endpoint, headers = {}) {
    return Http.delete(endpoint, {
      headers: this.assignHeaders(headers),
    });
  },
};
